import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  SendRequestCallback,
  CollectionFormData,
  CollectionsFormData,
  parseCollectionFormDataToParams,
  Collection,
} from "../../types";
import { showError } from "../notifications";

interface CreateCollectionType {
  sendRequest: SendRequestCallback<
    any,
    any,
    { data: Collection[]; count: number }
  >;
  filters: CollectionsFormData;
}

export const fetchCollections = createAsyncThunk(
  "collections/getCollections",
  async ({ sendRequest, filters }: CreateCollectionType, { dispatch }) => {
    try {
      const filterParams = parseCollectionFormDataToParams(filters);
      const response = await sendRequest("get")({
        url: `/org/collections${
          (filterParams?.length || 0) > 0 ? "/?" + filterParams : ""
        }`,
      });
      return response?.data;
    } catch (err) {
      // dispatch(showError("Failed to find Collections"));
      console.log(err);
    }
  }
);

interface UpdateCollectionType {
  sendRequest: SendRequestCallback<any, any, any>;
  collection: CollectionFormData;
}

export const updateCollection = createAsyncThunk(
  "collection/updateCollection",
  async ({ sendRequest, collection }: UpdateCollectionType, { dispatch }) => {
    try {
      let data: any = {};
      if (!collection.id) {
        return;
      }
      data["id"] = collection?.id;
      data["trapTypeId"] = collection?.trapTypeId?.id;
      data["collectionSiteId"] = collection?.collectionSiteId?.id;
      data["description"] = collection?.description;
      data["collectionDate"] = collection.collectionDate?.toISOString();
      await sendRequest("patch")({
        url: `/collection/${collection.id}`,
        data,
      });
      return data;
    } catch (err) {
      dispatch(showError("Failed to update Collections"));
      console.log(err);
    }
  }
);
